import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-fancy-detail',
  templateUrl: './fancy-detail.component.html',
  styleUrls: ['./fancy-detail.component.css']
})
export class FancyDetailComponent extends BaseClass<any> implements OnInit, OnChanges {

  @Input() data: any;
  @Output() betDt = new EventEmitter();
  @Output() multiMUpdate = new EventEmitter();
  @Output() updateData = new EventEmitter();
  @Output() changeExpo = new EventEmitter();
  @Output() closeBet = new EventEmitter();
  modalRef?: BsModalRef;

  public fancyData: any[] = [];
  public isFancy: boolean = true;
  public tabVal: any;
  public odds: any;
  public expo: any;
  public token: any;
  public betSlipData: any;
  public mmIds: any;
  public fancyRunMarketId: any = ''
  public fancyRun: any;
  public id: any;
  public book_name: any;

  constructor(public service: WebserviceService, private modalService: BsModalService) { super(document) }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnChanges() {

    if (this.data) {
      this.fancyData = this.data?.fancyData;
      this.isFancy = this.data?.isFancy;
      this.tabVal = this.data?.tabVal;
      this.odds = this.data?.odds;
      this.expo = this.data?.expo;
      this.mmIds = this.data?.mmIds;
      this.token = this.data?.token;
      this.betSlipData = this.data?.betSlipData;
    }
  }

  getTitle(e: any) {
    e['isSuspend'] = false;
    let status: any = '';
    if ((this.odds[`${e.market_id}`])) {
      if (this.odds[`${e.market_id}`]?.suspended == 1) {
        status = 'suspended';
        e['isSuspend'] = true;
      } else if (this.odds[`${e.market_id}`]?.ball_running == 1) {
        status = 'ball running';
        e['isSuspend'] = true;
      } else if (e?.bet_allow == 0) {
        e['isSuspend'] = true;
      }
    }
    e['susStatus'] = status;
    // return status;
  }

  isOpenBetSlip(item: any) {
    if (item.selection_id == this.id) {
      if ((item?.isSuspend == true && this.env.isBetOpenEnv == true)) {
        this.env.isBetOpenEnv = false;
        this.id = '';
      }
    }
    return this.env.isBetOpenEnv;

  }

  openBetPlace(item: any, oddsItem: any, i: any, bet: any, oi: any, bkOrLy: any, key: string) {
    // alert(this.id+"============"+item?.selection_id)
    this.env.isBetOpenEnv = true;
    this.id = item?.selection_id
    this.betDt.emit({ item: item, oddsItem: oddsItem, i: i, bet: bet, oi: oi, bkOrLy: bkOrLy, key: key })
  }

  fancyRunPosition(template: TemplateRef<any>, item: any) {
    if (this.expo[item?.market_id] && this.expo[item?.market_id][item?.selection_id]) {
      this.openModal(template);
      let tempReq = { "market_id": item.market_id }
      let req = this.JSON_to_URLEncoded(tempReq);
      this.getServices().Post(`${this.env.baseUrl + this.api.fancyRunPosition}`, req).subscribe(
        (res) => {
          if (res.status == true) {
            this.fancyRun = JSON.parse(res.data.position);
            this.book_name = item?.name;
          }
        },
        (err) => {
          console.log(err)
        });
    }
  }


  // fancyRunPosition(template: TemplateRef<any>, item: any) {
  //   if (this.expo[item?.market_id] && this.expo[item?.market_id][`${item?.selection_id}_expose`]) {
  //     this.openModal(template);
  //     this.fancyRunMarketId = item.market_id;
  //     let req = this.JSON_to_URLEncoded({ "market_id": item.market_id });
  //     this.getServices().Post(`${this.env.baseUrl + this.api.fancyRunPosition}`, req).subscribe(
  //       (res) => {
  //         if (res.status == true) {
  //           let fr = Object.keys(res.data.position).map((key: any) => ({ key: Number(key), value: res.data.position[key] }))

  //           if (fr[0].key > 4) {
  //             for (let i = 1; i <= 4; i++) {
  //               fr.unshift({ key: fr[0].key - 1, value: fr[0].value });
  //             }
  //           }
  //           for (let i = 1; i <= 4; i++) {
  //             fr.push({ key: fr[fr.length - 1].key + 1, value: fr[fr.length - 1].value });
  //           }
  //           this.fancyRun = fr;
  //         }
  //       },
  //       (err) => {
  //         console.log(err)
  //       });
  //   }
  // }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  multiMarketUpdate(item: any, key: any) {
    this.multiMUpdate.emit({ item: item, key: key });
  }

  ngAfterContentChecked() {
    this.fancyData.forEach((element) => {
      this.getTitle(element);
    });
  }

}
